'use client';

import Link from 'next/link';

import { UserAvatar } from '@daveyplate/better-auth-ui';
import { ChevronsUpDown, CircleQuestionMark, LogOut, Settings } from 'lucide-react';

import { OrganizationSwitcher } from '@/components/organization-switcher';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';
import { openHelpWidget } from '@/lib/help-widget';

const userNavItems = [
  // { href: '/dashboard', icon: Users, label: 'Team' },
  { href: '/settings/account', icon: Settings, label: 'Settings' },
  // { href: '/account/activity', icon: Activity, label: 'Activity' },
  { onClick: openHelpWidget, icon: CircleQuestionMark, label: 'Help' },
];

export function UserNav({
  user,
}: {
  user: {
    name: string | null;
    email: string;
    avatar?: string;
  };
}) {
  const { isMobile } = useSidebar();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="xl"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <UserAvatar user={user} />
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{user.name}</span>
                <span className="truncate text-xs">{user.email}</span>
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            side={isMobile ? 'bottom' : 'right'}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="text-xs opacity-70">Organization</DropdownMenuLabel>
            {/* variant=null ensures the switcher button doesn't have a bg color */}
            <OrganizationSwitcher variant={null} className="w-full px-1! py-1.5!" hidePersonal />
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              {userNavItems.map((item) => (
                <DropdownMenuItem asChild key={item.label}>
                  <Link href={item?.href || ''} onClick={item?.onClick}>
                    <item.icon />
                    {item.label}
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link href="/auth/sign-out">
                <LogOut />
                Sign out
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
